import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'
import { Layout, TextDetail, PrimaryButton } from '../components'
// mui
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
// firebase
import {db} from '../firebase'
// reducks
import { updateSubscription } from '../reducks/users/operations'

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}
const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

const CustomerDetail = ()=>{

    const dispatch = useDispatch()

    // URLからcontactIdを取得
    const selector = useSelector(state=>state)
    const path = selector.router.location.pathname
    const customerId = path.split('/customer/dp/')[1]

    const [customer, setCustomer] = useState()
    const [orders, setOrders] = useState([])
    const [isSubscribe, setIsSubscribe] = useState(true)

    // 該当カスタマーの情報を取得
    useEffect(()=>{
        db.collection('users').doc(customerId).get()
          .then(snapshot => {
              const data = snapshot.data()
                setCustomer(data)
                setIsSubscribe(data.is_subscribe)
          })
          .then(()=>{
            db.collection('users').doc(customerId)
              .collection('orders').orderBy('created_at','desc').get()
              .then(snapshots => {
                    const tempOrderList = []
                    snapshots.forEach(snapshot => {
                        tempOrderList.push(snapshot.data())
                    })
                    setOrders(tempOrderList)
              })
          })
    },[customerId])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>顧客詳細</h1>
            <div className='spacer-50' />
            {customer && (
                <Wrapper>
                    <TextDetail label={'顧客ID'} value={customer.uid} />
                    <TextDetail label={'姓'} value={customer.lastname} />
                    <TextDetail label={'名'} value={customer.firstname} />
                    <TextDetail label={'郵便番号'} value={customer.postalCode} />
                    <TextDetail label={'都道府県'} value={customer.prefecture} />
                    <TextDetail label={'市区町村'} value={customer.city} />
                    <TextDetail label={'番地以降'} value={customer.street} />
                    <TextDetail label={'メールアドレス'} value={customer.email} />
                    <TextDetail label={'電話番号'} value={customer.tel} />
                    <TextDetail label={'登録日時'} value={customer.created ? dateTimeToString(customer.created.toDate()) : ""} />
                    <TextDetail label={'更新日時'} value={customer.updated_at ? dateTimeToString(customer.updated_at.toDate()) : ""} />

                    <div className='spacer-50' />
                    <SubHeading>注文履歴</SubHeading>
                    {orders && orders.map(order=>(
                        <Accordion key={order.id}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                                <Typography>{order.created_at ? dateTimeToString(order.created_at.toDate()) : ""}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>ステータス：{order.status}</Typography>
                            </AccordionDetails>
                            <AccordionDetails>
                                <Typography>発送日：{order.shipping_date ? dateToString(order.shipping_date.toDate()) : ""}</Typography>
                            </AccordionDetails>
                            <AccordionDetails>
                                <Typography>合計金額：¥{order.amount}</Typography>
                            </AccordionDetails>
                            <AccordionDetails>
                                <Button color={'primary'} onClick={()=>dispatch(push('/admin/order/dp/'+order.id))} >注文詳細へ</Button>
                            </AccordionDetails>
                        </Accordion>
                    ))}

                    <div className='spacer-50' />
                    <SubHeading>メールマガジン購読設定</SubHeading>
                    <SwitchWrapper>
                        <div>ストアからのメールマガジン</div>
                        <Switch
                            color="primary" checked={isSubscribe}
                            onChange={()=>setIsSubscribe(!isSubscribe)}
                        />
                    </SwitchWrapper>
                    <div className='spacer-50' />
                </Wrapper>
            )}
            <div style={{textAlign:'center'}}>
                <PrimaryButton label="購読設定を変更する" operation={() => dispatch(updateSubscription(customerId, isSubscribe))} />
                <div className='spacer-50' />
                <Button onClick={()=>dispatch(push('/admin/customer'))}>顧客一覧に戻る</Button>
            </div>
            <div className='spacer-100' />

        </Layout>
    )
}
export default CustomerDetail

const Wrapper = styled.div`
    width: 480px;
    margin: 0 auto;
`
const SubHeading = styled.h4`
    font-size: 24px !important;
    margin-bottom: 24px;
`
const SwitchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`